module.exports = __webpack_public_path__ + "media/news.283095a8.mp4";